module.exports = __webpack_public_path__ + "img/card.3e89ba40.svg";